export default __webpack_public_path__ + "static/business-talks-f844c610d3e6ab6babd6060a690168cc.jpg";